import React from 'react';
import './Navigation.css';
import AuthNav from '../AuthNav/AuthNav';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import { Link } from 'react-router-dom';
import LogStream from '../../LogStream/LogStream';

const Navigation = () => {
  return (
    <nav className="navigation">
      <Breadcrumbs />
      <LogStream />
      <AuthNav />
    </nav>
  );
};

export default Navigation;